import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { formatAssociatedOrderNumberForDisplay } from '../../../util';
import CommonErrorContainer from '../../../containers/tools/CommonErrorContainer';
import { ORDER_TASKS } from '../../../util/toolsTasks';
import ShipstationShopIcon from '../ShipstationShopIcon/ShipstationShopIcon';
import { SEARCH_SUBSCRIPTIONS, MACRO_WIZARD } from '../../../constants/searchTypes';
import SearchPage from '../SearchPage/SearchPage';
import LoadingComponent from 'components/LoadingComponent/LoadingComponent';
import { COMMON } from 'constants/orderingSystems';
import {
  HeaderRow,
  BackButton,
  TaskPageWrapper,
  OrderNumberLabel,
  LoadingContainer,
  ShopifyWrapper,
} from './ActionsComponent.styles';

class ActionsComponent extends Component {
  deselectTask = () => {
    this.props.setSelectedTask(null);
    this.props.selectSubscriptionTask(null);
  };
  deselectOrder = () => this.props.selectOrder(null);
  deselectSubscription = () => this.props.selectSubscription(null);

  handleBackButtonClick = () => {
    const { selectedSubscription, searchType, subscriptionSelectedTask, ordersSearch } = this.props;

    if (ordersSearch.selectedTask || subscriptionSelectedTask) {
      return this.deselectTask();
    }
    if (searchType === SEARCH_SUBSCRIPTIONS && !isEmpty(selectedSubscription)) {
      return this.deselectSubscription();
    }
    this.deselectOrder();
  };

  /**
   * @return {SubscriptionModel}
   */
  get selectedSubscription() {
    return this.props.selectedSubscription;
  }

  render() {
    const { ordersSearch, selectedSubscription, searchType, selectedOrder, orderingSystem, toolsLoading } = this.props;
    const orderSearchViewNotSupported = !orderingSystem || orderingSystem === COMMON;

    if (toolsLoading) {
      return (
        <LoadingContainer>
          <LoadingComponent delay={0} marginTop={'0px'} />
        </LoadingContainer>
      );
    }

    // TODO: Add logic to only check the selectedOrder or selectedSubscription when the searchType requires it
    // if we are on another tab, we shouldn't care if we have a selectedSubscription
    if (
      (isEmpty(selectedOrder) && isEmpty(selectedSubscription)) ||
      orderSearchViewNotSupported ||
      searchType === MACRO_WIZARD
    ) {
      return (
        <div className="widget">
          <SearchPage />
        </div>
      );
    }

    const selectedTask = ordersSearch.selectedTask;
    let objectsListToUse = ORDER_TASKS[orderingSystem];
    let selectedTaskObject = objectsListToUse[selectedTask] || objectsListToUse['def'];
    let currentTaskComponent = ordersSearch.error ? <CommonErrorContainer /> : selectedTaskObject.page;

    // determine header content
    let orderNumber;
    let ticketNumber;
    let email;
    let detailTitle;
    switch (orderingSystem) {
      case 'shopify':
        orderNumber = formatAssociatedOrderNumberForDisplay(selectedOrder.name);
        break;
      case 'amazon':
        orderNumber = selectedOrder['AmazonOrderId'];
        break;
      case 'customSeller':
        email = selectedOrder['email'];
        break;
      case 'mock':
        ticketNumber = this.props.platformTicketId;
        break;
      case 'simplrOrder':
        orderNumber = selectedOrder['orderId'];
        break;
      case 'custom_rbi':
        orderNumber = selectedOrder['rbiOrderId'];
        break;
      case 'salesforce':
        orderNumber = selectedOrder['OrderNumber'];
        break;
      default:
        email = selectedOrder['email'];
        break;
    }

    if (ticketNumber && orderingSystem === 'mock') {
      detailTitle = `TICKET #${ticketNumber}`;
    } else {
      detailTitle = orderNumber ? `ORDER #${orderNumber}` : `EMAIL ${email}`;
    }

    const displayShipstationIcon = (ordersSearch.selectedConfig || {}).shipstataionInstalled;

    return (
      <ShopifyWrapper>
        <HeaderRow>
          <BackButton src="/images/curved-back-arrow.svg" alt="back-button" onClick={this.handleBackButtonClick} />
          <OrderNumberLabel>
            {detailTitle}
            {displayShipstationIcon && <ShipstationShopIcon />}
          </OrderNumberLabel>
        </HeaderRow>
        <TaskPageWrapper>{currentTaskComponent}</TaskPageWrapper>
      </ShopifyWrapper>
    );
  }
}

ActionsComponent.propTypes = {
  ordersSearch: PropTypes.shape({
    selectedTask: PropTypes.string,
    orderingSystem: PropTypes.string,
    selectedOrder: PropTypes.object,
  }).isRequired,
  simplrAccountPtrId: PropTypes.string,
  selectedSubscription: PropTypes.object,
  searchType: PropTypes.string,
  setSelectedTask: PropTypes.func.isRequired,
  selectOrder: PropTypes.func.isRequired,
};

export default ActionsComponent;
